const defaultGrid = { x: 1, y: 1, width: 0, height: 0 };
const currentOrigin = 'https://preview.testing.sparkdit.com';

export const fetchComponentTypeFromURL = (url: string): 'form' | 'flow' | 'iframe' => {
    if (!url) {
        return 'iframe';
    }

    if (url.startsWith(`${currentOrigin}/forms`)) {
        return 'form';
    }
    if (url.startsWith(`${currentOrigin}/flows`)) {
        return 'flow';
    }

    return 'iframe';
};

export const transformMashupFields = (
    data: any[],
) => {
    return data.map(item => {
        return {
            id: item.id || item.fieldID || item.name,
            title: item.title,
            src: item.src,
            type: fetchComponentTypeFromURL(item.src),
            layout: {
                desktop: item.view.desktop.grid || defaultGrid,
                // tablet: item.view?.tablet.grid || defaultGrid,
                // mobile: item.view?.mobile.grid || defaultGrid,
            },
        };
    });
};


export const getComponentIdFromURL = (url: string, type: 'forms' | 'flows'): string | null => {
    const regex = new RegExp(`/${type}/([^/]+)/?$`);
    const match = url.match(regex);

    return match ? match[1] : null;
};
